function _isPlaceholder(a) {
       return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}

/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
function _curry1(fn) {
  return function f1(a) {
    if (arguments.length === 0 || _isPlaceholder(a)) {
      return f1;
    } else {
      return fn.apply(this, arguments);
    }
  };
}

/**
 * Checks if the input value is `null` or `undefined`.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Type
 * @sig * -> Boolean
 * @param {*} x The value to test.
 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
 * @example
 *
 *      R.isNil(null); //=> true
 *      R.isNil(undefined); //=> true
 *      R.isNil(0); //=> false
 *      R.isNil([]); //=> false
 */
var isNil = /*#__PURE__*/_curry1(function isNil(x) {
  return x == null;
});

var storeUrl = {};
var cachePromise = function cachePromise(promiseCallback, url) {
  var promise = storeUrl[url];
  if (!isNil(promise)) {
    var shouldCreateNewPromise = promise.isFulfilled() || promise.isRejected() || promise.isCancelled();
    if (shouldCreateNewPromise) {
      var _newPromise = MakeQueryablePromise(promiseCallback());
      storeUrl[url] = _newPromise;
      return _newPromise;
    }
    return promise;
  }
  var newPromise = MakeQueryablePromise(promiseCallback());
  storeUrl[url] = newPromise;
  return newPromise;
};
function MakeQueryablePromise(promise) {
  if (promise.isResolved) return promise;
  var isPending = true;
  var isFulfilled = false;
  var isRejected = false;
  var isCancelled = false;
  var result = promise.then(function (v) {
    isFulfilled = true;
    isPending = false;
    return v;
  }, function (e) {
    isRejected = true;
    isPending = false;
    throw e;
  });
  if (result["finally"]) {
    result["finally"](function () {
      if (promise.isCancelled()) {
        isCancelled = true;
      }
    });
  }
  result.isPending = function () {
    return isPending;
  };
  result.isFulfilled = function () {
    return isFulfilled;
  };
  result.isRejected = function () {
    return isRejected;
  };
  result.isCancelled = function () {
    return isCancelled;
  };
  result.promise = promise;
  return result;
}

export { cachePromise };



//////////////////
// WEBPACK FOOTER
// ../packages/cache-promise/es/index.js
// module id = 3950
// module chunks = 13